import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Testing = () => {
    return (
        <div className="pochtabank-testing">
            <FullWrapper caseName="pochtabank-testingCase">
                <div className="pochtabank-testingTitle">Тестирование</div>
                <div className="pochtabank-testingInner">
                    <div className="pochtabank-testingLeft">
                        В&nbsp;качестве приемочных автотестов использовали популярный framework
                        на&nbsp;TypeScript: Playwright (Open source инструмент от&nbsp;Microsoft).
                        Мы&nbsp;интегрировали автотесты в&nbsp;Gitlab CI&nbsp;для улучшения
                        процессов развития проекта при внесении изменений. Написанные тесты
                        на&nbsp;TypeScript в&nbsp;теории могут поддерживать
                        и&nbsp;frontend-разработчики. Это удобно, когда&nbsp;разработчики пишут
                        на&nbsp;одном языке.
                    </div>
                    <div className="pochtabank-testingRight">
                        <div className="pochtabank-testingRightText">
                            Инструмент автоматизации тестирования
                        </div>
                        <div className="pochtabank-testingRightItem">
                            <img
                                src="/images/svg/new-pochtabank/playwright.svg"
                                alt="icon"
                                className="pochtabank-testingRightIcon"
                            />
                            <div className="pochtabank-testingRightName">Playwright</div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Testing;
